var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter-container"},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"info-wrapper"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('view_counter_viewed_times', { visits: _vm.visits }))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }